import { useEffect, useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import fetchData from "../custom_functions/fetchData";
import postData from "../custom_functions/postData";
import Input from "../reusable_components/Input";
import Select from "../reusable_components/Select";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";


function AddFaq(props) {
    const [formData, setFormData] = useState({});
    const [carInfo, setCarInfo] = useState({});
    const [cars, setCars] = useState([]);
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);

    const requiredFields = ['problem', 'problemDescription', 'solution']

    useEffect(() => { fetchCars() }, [])

    async function addFaq() {
        if (
            carInfo.make &&
            carInfo.model &&
            carInfo.year &&
            formData.problem && formData.problem.length > 0 &&
            formData.problemDescription && formData.problemDescription.length > 0 &&
            formData.solution && formData.solution.length > 0 &&
            !inputErrors.includes('error')
        ) {
            const car_id = cars.filter(car => car.make === carInfo.make && car.model === carInfo.model && car.year === carInfo.year)[0]['id'];
            postData(`${url}/faq`, { ...formData, car_id }, (error) => {
                toast.error(error.response.data.message, { autoClose: 3000 })
            }, (data) => {
                toast.success(data.message, { autoClose: 3000 })
                props.setShowModal(false)
                props.reload(1 + Math.random())
            })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    async function fetchCars() {
        fetchData(`${url}/cars`, (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }, (data) => {
            setCars(data.data)
        })
    }

    function getMakeList() {
        const make = [];
        cars.forEach(car => {
            if (!make.includes(car.make)) {
                make.push(car.make)
            }
        })
        return make;
    }

    function updateFormData(e) {
        const { name, value } = e.target;
        var data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    function updateCarInfo(e) {
        const { name, value } = e.target;
        if (value !== 1) {
            var data = { ...carInfo };
            data[name] = value;
            setCarInfo(data);
        }
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-lg p-4 w-2/3">
                <div className={modalTitle}>Add FAQ</div>
                <div>
                    <div className="flex w-full">
                        <div className="w-full">

                            <Select
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                className={inputStyle}
                                name='make'
                                placeHolder='Make'
                                value={carInfo.make}
                                options={getMakeList()}
                                onChange={e => updateCarInfo(e)}
                            />
                        </div>
                        <div className="w-full mx-1">

                            <Select
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                className={inputStyle}
                                name='model'
                                placeHolder='Model'
                                value={carInfo.model}
                                valueKey={'model'}
                                nameKey={'model'}
                                options={cars.filter(car => car.make === carInfo.make)}
                                onChange={e => updateCarInfo(e)}
                            />
                        </div>
                        <div className="w-full">

                            <Select
                                index={2}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                className={inputStyle}
                                name='year'
                                placeHolder='Year'
                                value={carInfo.year}
                                valueKey={'year'}
                                nameKey={'year'}
                                options={cars.filter(car => car.make === carInfo.make && car.model === carInfo.model)}
                                onChange={e => updateCarInfo(e)}
                            />
                        </div>
                    </div>
                    <Input
                        index={3}
                        inputErrors={inputErrors}
                        setInputErrors={setInputErrors}
                        missingFields={missingFields}
                        required={true}
                        className={inputStyle}
                        name='problem'
                        placeHolder='Enter Problem'
                        value={formData.problem}
                        onChange={e => updateFormData(e)}
                    />
                    <div className="flex gap-2">
                        <textarea
                            className={inputStyle}
                            name='problemDescription'
                            placeholder="Enter Problem Description"
                            value={formData.problemDescription}
                            onChange={e => updateFormData(e)}
                        />
                        <textarea
                            className={inputStyle}
                            name='solution'
                            value={formData.solution}
                            placeholder="Enter Solution"
                            onChange={e => updateFormData(e)}
                        />
                    </div>
                    <div className="flex gap-2">
                        <Input
                            index={6}
                            inputErrors={inputErrors}
                            setInputErrors={setInputErrors}
                            missingFields={missingFields}
                            required={true}
                            className={inputStyle}
                            name="recommendation"
                            placeHolder='Enter Recommendation'
                            value={formData.recommendation}
                            onChange={e => updateFormData(e)}
                        />
                        <Input
                            index={10}
                            inputErrors={inputErrors}
                            setInputErrors={setInputErrors}
                            missingFields={missingFields}
                            required={true}
                            className={inputStyle}
                            name="vin"
                            placeHolder='Enter VIN'
                            value={formData.vin}
                            onChange={e => updateFormData(e)}
                        />
                    </div>
                    <div className="flex w-full">
                        <div className="w-full">

                            <Input
                                index={7}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name="partManufacturer"
                                placeHolder='Enter Part Manufacturer'
                                value={formData.partManufacturer}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="w-full mx-1">

                            <Input
                                index={8}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name="partNumber"
                                placeHolder='Enter Part Number'
                                value={formData.partNumber}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="w-full">

                            <Input
                                index={9}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name="costInvolved"
                                placeHolder='Enter Cost'
                                value={formData.costInvolved}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="flex justify-between py-3 px-16 gap-8">
                        <button onClick={() => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                        <Button clickHandler={() => addFaq()} className={btnOne} name={'Submit'} />
                    </div>
                    <div className="text-red-500 font-semibold text-center">
                        {
                            showInputError && 'Please fill all the fields as directed!'
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AddFaq;